import React from "react";
import styled from "styled-components";
import { InvestButton } from "./InvestButton";
import { StyledButton } from "@app/common/components/Button.styles";
import { resource } from "@app/common/localization/resource";
import cover from "@app/common/images/landing-page-cover.png";

export const Jumbotron: React.VFC = () => (
  <StyledJumbotronWrapper>
    <div className="container">
      <div className="row">
        <div className="col-md-8 col-lg-6 col-xl-5">
          <h1>{resource("landing.landingPageTitle")}</h1>
          <p>{resource("landing.landingPageDescription")}</p>
          <InvestButton>{resource("landing.btnStart1")}</InvestButton>
        </div>
      </div>
    </div>
  </StyledJumbotronWrapper>
);

const StyledJumbotronWrapper = styled.div`
  background-size: cover;
  /* Navy scrim keeps the white logo, menu and headline legible over the light cover photo */
  background-image: linear-gradient(to bottom, rgba(1, 38, 57, 0.6), rgba(1, 38, 57, 0.35)), url(${cover});
  padding: 220px 0 200px;
  color: #fff;

  h1 {
    margin: 0 0 10px;
    font-size: 50px;
    font-weight: 700;
  }

  p {
    margin: 0 0 30px;
    font-size: 18px;
    font-weight: 600;
  }

  ${StyledButton} {
    font-size: 24px;
  }
`;
